import React, { useContext } from "react"
import GameContext from "../../../Context/GameContext"
import { actions } from "../../shared/constants"
import { createHostAction } from "../createHostAction"
import { Slides } from "../slides/Slides"
import { fallbackContent } from "../../shared/fallbackContent"
import { defaultLabels } from "../../shared/defaultLabels"

export const RoundOutro = props => {
  const { gameData, gameState, onAction } = useContext(GameContext)
  const roundIndex = gameState?.roundIndex
  if (!(Number.isInteger(roundIndex) || roundIndex < 0))
    return <div>Incorrect round-index</div>
  const roundData = gameData?.rounds[roundIndex]
  if (!roundData) return <div>round-data not found</div>

  const handleEnd = () => {
    onAction(createHostAction(actions.HOST_PREPARE_NEXT_ROUND))
  }

  const content =
    roundData.round_outro?.host_slides ||
    fallbackContent.round_outro.host_slides

  const previous =
    gameData?.game_defaults?.host_previous_button ||
    defaultLabels?.GAME_DEFAULTS_HOST_PREVIOUS_BUTTON

  const next =
    gameData?.game_defaults?.host_next_button ||
    defaultLabels?.GAME_DEFAULTS_HOST_NEXT_BUTTON

  const end =
    roundData.round_outro?.host_last_slide_button ||
    defaultLabels?.ROUND_INTRO_LAST_SLIDE_BUTTON

  const backgroundImage = roundData?.host_background_image || null

  return (
    <Slides
      content={content}
      labels={{
        previous,
        next,
        end,
      }}
      handleEnd={handleEnd}
      backgroundImage={backgroundImage}
    />
  )
}
